import React from 'react';

function NormalCard(props) {
    const { title, children, contClasses } = props;
    return (
        <div className={`item-card-container ${contClasses}`}>
            <div className='main-card flex-size-full'>
                <label className='general-card-name'>{title}</label>
                {children}
            </div>
        </div >
    )
}

export default NormalCard